import { customisedContactDetails } from "./customised-contact-details";
import { form } from "./form";
import { slug } from "./slug";
import { submission } from "./submission";
import { submissionLinkHash } from "./submission-link-hash";
import { team } from "./team";
import { tracker } from "./tracker";
import { user } from "./user";
import { RuleEvaluators } from "../types";

export const rules: RuleEvaluators = {
  customisedContactDetails,
  form,
  slug,
  submission,
  submissionLinkHash,
  team,
  tracker,
  user,
};
